import { DamageCategoryActionTypes, DamageCategoryTypes } from "./damageCategoryTypes";
import { DamageCategoryResponse } from "@/main/models/response/damageCategoryResponse";

export function getDamageCategories(guidInsurer: string): DamageCategoryActionTypes {
	return {
		type: DamageCategoryTypes.GET_DAMAGE_CATEGORIES,
		payload: { guidInsurer },
	};
}

export function saveDamageCategories(
	data: DamageCategoryResponse[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): DamageCategoryActionTypes {
	return {
		type: DamageCategoryTypes.SAVE_DAMAGE_CATEGORIES,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerDamageCategories(): DamageCategoryActionTypes {
	return {
		type: DamageCategoryTypes.RESET_REDUCER_DAMAGE_CATEGORIES,
	};
}
